import React from 'react';

export const SwapHero = () => {
  return (
    <div className="swap-header">
      <p className="swap-eyebrow">Nova USD (USDN)</p>
      <h1 className="swap-title" id="swap-title">
        Get <br />
        <span className="title-nova">Un</span>tethered
      </h1>
      <div className="swap-subtitle">
        <p>Swap USDT or USDC to USDN. You only pay network gas.</p>
        <p>Fully onchain, straight from your own wallet.</p>
        <p className="swap-subtitle-muted">More chains and stablecoins coming soon.</p>
      </div>
    </div>
  );
};
